import { colors } from '@btime/constants'
import { propOr } from 'ramda'

const STATUS_COLORS = {
  available: colors.green,
  unavailable: colors.red
}

export const getAvailabilityStatusColor = status => propOr(colors.dark5, status, STATUS_COLORS)
